package de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification

import de.oevbs.businesspartner.bpcrmservice2.proposal.model.SalesProduct
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class LifeContract(
    val contractNumber: String = "",
    val branchGroup: String = "",
    val salesProduct: String = SalesProduct.Unbekannt.value,
    val additionalLine2: String = ""
) {
    companion object
}

@Lenses
@Serializable
data class LifeValueNotification(
    val lifeContracts: List<LifeContract> = emptyList(),
    val selectedContracts: List<LifeContract> = emptyList()
) {
    companion object {
        val validation: Validation<LifeValueNotification, Unit, ComponentValidationMessage> = validation { inspector ->
            val contracts = inspector.map(LifeValueNotification.selectedContracts())
            if (contracts.data.isEmpty()) {
                add(contracts.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }
        }
    }
}